import { Attachment, FileGenerationStatus } from "../types/chat";
import { Download, Loader2 } from "lucide-react";
import { downloadFileById } from "services/storage-service";
import { useConfig } from "hooks/use-config";
import { useTheme } from "components/core/theme-provider";
import { Button } from "components/ui/button";

type DownloadAssistantFileProps = {
  file: Attachment;
  variant?: 'icon' | 'labeled';
};

export const DownloadAssistantFile = ({
  file,
  variant = 'icon',
}: DownloadAssistantFileProps) => {
  const { configurationSettings } = useConfig();
  const { theme } = useTheme();

  const downloadFile = async (fileId: string) => {
    await downloadFileById(fileId, file.fileName, configurationSettings, undefined);
  };

  if (file.sender === 'assistant' && file.status && file.status === FileGenerationStatus.IN_PROGRESS) {
    return <Loader2 className="h-4 w-4 animate-spin text-primary" />;
  }

  if (variant === 'labeled') {
    return (
      <Button
        type="button"
        variant="outline"
        size="sm"
        title="Download file"
        className="h-8 min-w-[5.75rem] shrink-0 rounded-lg border-border bg-background pl-4 pr-3 text-sm font-medium text-foreground shadow-none hover:bg-muted"
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          downloadFile(file.fileId);
        }}
      >
        Download
      </Button>
    );
  }

  return (
    <button
      type="button"
      title="Download file"
      className="flex h-8 w-8 items-center justify-center rounded-full p-1 text-gray-500 hover:bg-muted dark:text-gray-400"
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        downloadFile(file.fileId);
      }}
    >
      <Download className={`h-4 w-4 ${theme === 'dark' ? 'text-true-white' : 'text-[#3D3D3D]'}`} />
    </button>
  );
};